import axios from "axios";
import { FileUploadComplete } from './types';

export const fileUploadComplete = async (props: FileUploadComplete) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_PROXY_URL}/v1/upload/complete`,
      {
        action: "complete",
        object_name: props.objectName,
        upload_id: props.uploadId,
        parts: props.parts,
        compound_number: props.compoundNumber,
        protocol_number: props.protocolNumber,
        transfer_id: props.transferId,
        environment: props.environment,
        is_data_format: props.isDataFormat,
        is_offline_flow: props.isOfflineFlow,
      },
      {
      headers: {
        Authorization: "Basic " + process.env.REACT_APP_AUTHORIZATION_KEY,
        "x-merck-apikey": process.env.REACT_APP_X_MERCK_API_KEY,
      },
    });
    return response.data;
  } catch (e: any) {
    const message =
      e?.response?.data?.message ||
      e?.response?.data?.error ||
      e?.message ||
      "Failed to complete file upload.";
    return { error: true, message };
  }
};
